module.exports = __webpack_public_path__ + "cancellara-dist/img/doubleyou.ff9e50c5.png";